import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { setLoading } from "../../../../../redux/Loading/actions";
import { getAbogados } from "../../../../../redux/Sections/Abogados/actions";
import { showTable } from "../../../../../redux/Sections/Inmuebles/actions";
import { useUser } from "../../../../../hooks/useUser";
import { situacionesService } from "../../../../../_services/situaciones.service";
import Select from "../../../../../components/Select";

const emptyOption = { value: "", label: "Seleccionar..." };

export const ContribuyentesFilter = ({ action, reference, showFilter, setShowFilter, setShowTable }) => {
  const { abogadosList } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();
  const user = useUser();

  const {
    register,
    control,
    handleSubmit,
    reset
  } = useForm({});

  const [tags, setTags] = useState({});

  const [tipos, setTipos] = useState([]);
  const [situacion, setSituacion] = useState("");

  const [abogado, setAbogado] = useState("");

  useEffect(() => {
    const getData = () => {
      dispatch(getAbogados());
    };

    getData();
  }, []);


  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));

      let response = await situacionesService.getSituaciones();

      if (response?.length) {
        setTipos(response.map(e => {
          return {
            ...e,
            value: e.CODIGO,
            label: e.DETALLE_SITUACION
          };
        }));

        dispatch(setLoading(false));
      }
      else {
        dispatch(setLoading(false));
      }
    };

    getData();
  }, []);


  const handleClean = () => {
    reset({});
    setTags({});
    setSituacion({});
    setAbogado({});
  };

  const onSubmit = async (data) => {
    for (const value in data) {
      if (!data[value]) {
        delete data[value];
      }
    }

    if (Object.keys(data).length === 1 && data.situacion) {
      return Swal.fire({
        title: "No es posible buscar solo por 'estados'.",
        icon: "warning"
      }
      );
    }

    setTags(data);

    if (data.nombre) {
      data.nombre = data.nombre.toUpperCase();
    }

    if("A00" !== user?.abogado){
      data.abogado = user.abogado;
    }

    dispatch(action(data));

    setShowFilter(false);
    if (setShowTable) {
      setShowTable(true);
    }
    dispatch(showTable());
  };


  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Contribuyente</Form.Label>
              <Form.Control
                name="nombre"
                {...register("nombre")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">N° imponible</Form.Label>
              <Form.Control
                name="nro_imponible"
                {...register("nro_imponible")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Recurso</Form.Label>
              <Form.Control
                name="recurso"
                {...register("recurso")}
              />
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Barrio</Form.Label>
              <Form.Control
                name="barrio"
                {...register("barrio")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Calle</Form.Label>
              <Form.Control
                name="calle"
                {...register("calle")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Altura</Form.Label>
              <Form.Control
                name="altura"
                {...register("altura")}
              />
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">DNI</Form.Label>
              <Form.Control
                name="dni"
                {...register("dni")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">CUIM</Form.Label>
              <Form.Control
                name="cuim"
                {...register("cuim")}
              />
            </Col>
          </Row>
          <Row >
            {user?.rol === "admin" ? (
              <Col sm={12} md={4} className="mt-3">
                <Form.Label className="mb-2">Abogado</Form.Label>
                <Controller
                  name="abogado"
                  control={control}
                  render={({ field: { onChange } }) => {
                    let options = abogadosList?.length ? abogadosList.map(e => {
                      return {
                        ...e,
                        value: e.codexterno,
                        label: `${e.apellido} ${e.nombre}`
                      };
                    }) : [];

                    return (
                      <Select
                        options={options?.length ? [emptyOption, ...options] : [emptyOption]}
                        onChange={(e) => {
                          setAbogado(e);
                          return onChange(e.value);
                        }}
                        value={abogado}
                      />
                    );
                  }}
                />
              </Col>
            ) : null}

            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Estados</Form.Label>
              <Controller
                name="situacion"
                control={control}
                render={({ field: { onChange } }) => {
                  return (
                    <Select
                      options={tipos?.length ? [emptyOption, ...tipos] : [emptyOption]}
                      value={situacion}
                      onChange={(e) => {
                        setSituacion(e);
                        return onChange(e?.value);
                      }}
                    />
                  );
                }}
              />
            </Col>
          </Row>
          
          <Row className=" d-flex justify-content-end" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                ref={reference}
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {tags?.nombre &&
              <div className="tags">
                <span key="nombre" >
                  Nombre : {tags.nombre}
                </span>
              </div>}

            {tags?.nro_imponible &&
              <div className="tags">
                <span key="nro_imponible" >
                  Número Imponible : {tags.nro_imponible}
                </span>
              </div>}

            {tags.domicilio &&
              <div className="tags">
                <span key="domicilio" >
                  Domicilio : {tags.domicilio}
                </span>
              </div>}

            {tags.barrio &&
              <div className="tags">
                <span key="barrio" >
                  Barrio : {tags.barrio}
                </span>
              </div>}

            {tags.recurso &&
              <div className="tags">
                <span key="recurso" >
                  Recurso : {tags.recurso}
                </span>
              </div>}

            {tags.abogado &&
              <div className="tags">
                <span key="abogado" >
                  Abogado : {tags.abogado}
                </span>
              </div>}


            {/* {tags.estado &&
              <div className="tags">
                <span key="partidaInmobiliaria" >
                  Grupo : {grupo?.nombre}
                </span>
              </div>} */}

            {tags.situacion &&
              <div className="tags">
                <span key="estado" >
                  Estado : {situacion?.label}
                </span>
              </div>}

            {tags.calle &&
              <div className="tags">
                <span key="calle" >
                  Calle: {tags.calle}
                </span>
              </div>}

            {tags.altura &&
              <div className="tags">
                <span key="altura" >
                  Altura : {tags.altura}
                </span>
              </div>}

            {tags.partida &&
              <div className="tags">
                <span key="partidaInmobiliaria" >
                  Partida Inmobiliaria : {tags.partida}
                </span>
              </div>}

            {tags?.circ && (
              <div className="tags">
                <span color="green" key="circ">
                  Circ : {tags?.circ}
                </span>
              </div>
            )}

            {tags?.secc && (
              <div className="tags">
                <span color="green" key="partidaInmobiliaria">
                  Secc : {tags?.secc}
                </span>
              </div>
            )}

            {tags?.chN && (
              <div className="tags">
                <span color="green" key="chN">
                  Ch Nro : {tags?.chN}
                </span>
              </div>
            )}

            {tags?.chL && (
              <div className="tags">
                <span color="green" key="chL">
                  Ch Lta : {tags?.chL}
                </span>
              </div>
            )}

            {tags?.qtN && (
              <div className="tags">
                <span color="green" key="qtN">
                  Qt Nro : {tags?.qtN}
                </span>
              </div>
            )}

            {tags?.qtL && (
              <div className="tags">
                <span color="green" key="qtL">
                  Qt Lta : {tags?.qtL}
                </span>
              </div>
            )}

            {tags?.frN && (
              <div className="tags">
                <span color="green" key="frN">
                  Fr Nro : {tags?.frN}
                </span>
              </div>
            )}

            {tags?.frL && (
              <div className="tags">
                <span color="green" key="frL">
                  Fr Lta : {tags?.frL}
                </span>
              </div>
            )}

            {tags?.mzN && (
              <div className="tags">
                <span color="green" key="mzN">
                  Mz Nro : {tags?.mzN}
                </span>
              </div>
            )}

            {tags?.mzL && (
              <div className="tags">
                <span color="green" key="mzL">
                  Mz Lta : {tags?.mzL}
                </span>
              </div>
            )}

            {tags?.pcN && (
              <div className="tags">
                <span color="green" key="pcN">
                  Pc Nro : {tags?.pcN}
                </span>
              </div>
            )}

            {tags?.pcL && (
              <div className="tags">
                <span color="green" key="pcL">
                  Pc Lta : {tags?.pcL}
                </span>
              </div>
            )}

            {tags?.sbPc && (
              <div className="tags">
                <span color="green" key="sbPc">
                  Sub Pc : {tags?.sbPc}
                </span>
              </div>
            )}

            {tags?.dni && (
              <div className="tags">
                <span color="green" key="dni">
                  DNI : {tags?.dni}
                </span>
              </div>
            )}

            {tags?.cuim && (
              <div className="tags">
                <span color="green" key="cuim">
                  CUIM : {tags?.cuim}
                </span>
              </div>
            )}
          </Row>
        }
      </>
    </div>
  );
};
